<template>
	<div class="section">
		<div class="container is-large">
			<div class="section-body">
				<div class="section-background">
					<div class="section-title is-small">
						<div class="item-img">
							<img
								src="@/assets/add_user.png"
								alt="invite"
							>
						</div>
						Use this link to invite a friend
					</div>
					<router-link
						v-if="invitationCode"
						v-slot="{ href }"
						:to="{ name: 'Invitation', params: { invitationCode } }"
					>
						<LinkCopyInput
							:value="getInviteURL(href)"
							class="input-copy"
						>
							invitation URL
						</LinkCopyInput>
					</router-link>
					<div class="section-note">
						<div>NOTE:</div>
						<div>
							This link is only good to go for one friend! Just copy this link and send it to your friend.
							<br>You know more people you want to inform about RediR? No problem - just reload this page or go to the dashboard and come back again.
							<br>Either way a new redir.love invitation link will be created for your next friend.
						</div>
					</div>
					<router-link :to="{name: 'Dashboard'}">
						<div class="buttons">
							<AppButton
								size="medium"
								color="outline-light"
							>
								Go back
							</AppButton>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LinkCopyInput from '@/components/LinkCopyInput.vue';
import { mapActions } from 'vuex';

export default {
	name: 'Invite',

	components: {
		LinkCopyInput,
	},

	data() {
		return {
			invitationCode: '',
		};
	},

	async mounted() {
		this.invitationCode = await this.getInviteCode();
	},

	methods: {
		...mapActions([
			'getInviteCode',
		]),
		getInviteURL(href) {
			return `${window.origin}${href.startsWith('/') ? href : `/${href}`}`;
		},
	},

};
</script>

<style lang="scss" scoped>
.section {
	background-color: $color-black;
	color: $color-white;

	.section-background {
		width: 100%;
		max-width: 1096px;
		height: fit-content;
		margin-left: auto;
		margin-right: auto;
		padding: $gap-4 $gap-6;
		background-color: $color-accent-600;
	}

	.section-title {
		display: flex;
		align-items: flex-start;
		margin-bottom: $gap-4;

		img {
			width: 25px;
			margin-right: $gap-15;
		}
	}

	.section-subtitle {
		color: $color-accent-200;
		margin-top: $gap-4;
	}

	.section-description {
		color: $color-accent-200;
		margin-top: $gap-5;
		margin-bottom: $gap-05;
	}

	.section-note {
		display: flex;
		color: $color-accent-300;
		margin: $gap-1 $gap-05 * -1;
		border-radius: $vs-border-radius;
		font-size: $size-7;
		font-weight: $fontWeight-medium;
		line-height: $lineHeight-medium;

		div {
			margin: $gap-05;
		}
	}

	.buttons {
		margin-top: $gap-5;
		display: flex;
		justify-content: flex-end;
	}
}
</style>
